import { useEffect, useState } from 'react';
import { Spinner, Group, Header } from '@vkontakte/vkui';
import ErrorBlock from './ErrorBlock';
import ResultView from './ResultView';

function ApiWidget() {
    const [data, setData] = useState(null);
    const [token, setToken] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const login = {
        username: 'mobile-app',
        password: 'm0b1le0323',
    };

    const urlFetch = 'https://api.nmbook.ru/login';
    const postData = `username=${encodeURIComponent(login.username)}&password=${encodeURIComponent(login.password)}`;

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Получаем токен
                const responseToken = await fetch(urlFetch, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: postData,
                });

                const tokenData = await responseToken.json();

                if (!responseToken.ok) {
                    throw new Error('Ошибка при получении токена');
                }

                const token = tokenData.access_token;
                setToken(token);

                // Формируем фильтр
                const filter = JSON.stringify({
                    "death.month": new Date().getMonth() + 1,
                    "death.day": new Date().getDate(),
                });

                const apiUrl = `https://api.nmbook.ru/public/dela?data_format=full&filter=${encodeURIComponent(filter)}`;

                const responseData = await fetch(apiUrl, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                });

                const resultData = await responseData.json();

                if (!responseData.ok) {
                    throw new Error('Ошибка при получении данных');
                }

                setData(resultData);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [postData]);

    if (loading) {
        return (
            <Group header={<Header mode="secondary">Загрузка</Header>} style={{ textAlign: 'center' }}>
                <Spinner size="xl" />
            </Group>
        );
    }

    if (error) {
        return <ErrorBlock message={error} />;
    }

    return <ResultView data={data} token={token} />;
}

export default ApiWidget;
